import { Box } from './server/box';

export class BoxInfos extends Box {
    public count: number;
    public selected: boolean;

    public constructor(box: Box) {
        super();
        this.id = box.id;
        this.name = box.name;
        this.order = box.order;
        this.groupId = box.groupId;
        this.defaultBox = box.defaultBox;
        this.count = 0;
        this.selected = false;
    }
}
